module.exports = __webpack_public_path__ + "img/arhipov.51a7b568.jpg";